import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import wrapInContainerStyles from "@insite/client-framework/Common/wrapInContainerStyles";
import { ProductContextModel } from "@insite/client-framework/Components/ProductContext";
import { CartLineModel, OrderLineModel } from "@insite/client-framework/Types/ApiModels";
import Link, { LinkPresentationProps } from "@insite/mobius/Link";
import Typography, { TypographyProps } from "@insite/mobius/Typography";
import React, { useState } from "react";
import { css } from "styled-components";

interface OwnProps {
    product: CartLineModel | ProductContextModel | OrderLineModel;
    extendedStyles?: ProductDescriptionStyles;
    onClick?: React.EventHandler<React.MouseEvent>;
    target?: string;
}

type Props = OwnProps;

export interface ProductDescriptionStyles {
    productDetailLink?: LinkPresentationProps;
    productDetailDescription?: TypographyProps;
}

export const productDescriptionStyles: ProductDescriptionStyles = {
    productDetailLink: {
        css: css`
            width: 100%;
            h2 {
                word-break: break-word;
            }
        `,
        typographyProps: {
            css: css`
                width: 100%;
                ${wrapInContainerStyles}
            `,
        },
    },

    productDetailDescription: {
        css: css`
            word-break: break-word;
            font-weight: bold;
        `,
    },
};

const ProductDescription = ({ product, onClick, extendedStyles, target }: Props) => {
    const [styles] = useState(() => mergeToNew(productDescriptionStyles, extendedStyles));

    const description =
        "product" in product
            ? product.product.productTitle
            : product.shortDescription || ("description" in product ? product.description : "");
    const productDetailPath = "product" in product ? product.productInfo.productDetailPath : product.productUri;

    return productDetailPath && (!("isActiveProduct" in product) || product.isActiveProduct) ? (
        target === "blank" ? (
            <Link
                {...styles.productDetailLink}
                href={productDetailPath}
                alt={`See product details for ${description}`}
                data-test-selector="productDescriptionLink"
                target="_blank"
                onClick={onClick}
            >
                <Typography as="h2">{description}</Typography>
            </Link>
        ) : (
            <Link
                {...styles.productDetailLink}
                onClick={onClick}
                href={productDetailPath}
                data-test-selector="productDescriptionLink"
            >
                <Typography as="h2">{description}</Typography>
            </Link>
        )
    ) : (
        <Typography {...styles.productDetailDescription} as="h2">
            {description}
        </Typography>
    );
};

export default ProductDescription;
